import { useEffect, useState } from "react";
import {
  userRefreshToken,
  validateTokenAndSignin,
} from "../api/auth";
import {
  getCategoryList,
  getIndustryList,
  getNoOfEmpList,
  getOpportunityCategoryList,
  getTimezoneList,
  getTitleList,
  getTopicList,
} from "../api/common";
import Routes from "../routes";
import { useAppDispatch, useAppSelector } from "../store";
import { LoadingSpinner } from "../components/loading-spinners";
import {
  setInitialListFetched,
} from "../store/modules/UI";
import { useNavigate } from "react-router";
import { ROUTE_PATHS } from "../routes/paths";
import { checkIsNoInitialConfigRequiredRoutes } from "../services/utils";

export default function Screens() {
  const [initialLoading, setInitialLoading] = useState(true);
  const { initialListFetched } = useAppSelector((state) => state.UI);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    onMount();
  }, []);

  useEffect(() => {
    !initialListFetched && loadLists();
  }, [initialListFetched]);

  const onMount = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get("token");

    if (checkIsNoInitialConfigRequiredRoutes()) {
      dispatch(setInitialListFetched(true));
      setInitialLoading(false);
      return;
    }


    if (
      token &&
      !localStorage.getItem("refreshToken") &&
      (window.location.pathname.includes("/project/invitation") || window.location.pathname.includes("/project/invitation-reminder")) &&
      !window.location.pathname.includes("/project/invitation/preview")
    ) {
      const res: any = await dispatch(validateTokenAndSignin(token));

      if (res.success) {
        urlSearchParams.delete("token");
        const search = urlSearchParams.toString();
        navigate(
          `${window.location.pathname}${search ? `?${search}` : ""}`,
          { replace: true }
        );
      } else {
        navigate(ROUTE_PATHS.AUTH.LOGIN);
      }
    }

    if (localStorage.getItem("refreshToken")) {
      await dispatch(userRefreshToken());
    }

    setInitialLoading(false);
  };

  const loadLists = () => {
    if (checkIsNoInitialConfigRequiredRoutes()) {
      dispatch(setInitialListFetched(true));
      setInitialLoading(false);
      return;
    }

    Promise.all([
      dispatch(getIndustryList()),
      dispatch(getTitleList()),
      dispatch(getTimezoneList()),
      dispatch(getCategoryList()),
      dispatch(getNoOfEmpList()),
      dispatch(getTopicList()),
      dispatch(getOpportunityCategoryList()),
    ]).finally(() => {
      dispatch(setInitialListFetched(true));
    });
  };

  return (
    <>
      {initialLoading ? (
        <LoadingSpinner loading={initialLoading} />
      ) : (
        <Routes />
      )}
    </>
  );
}
